import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'
import isObject from '../../utils/object'

export default {
  namespaced: true,
  actions: {
    async updateSupplier(context, supplier) {
      const response = await http.put(`supplier/${supplier.id}`, {
        name: supplier.name,
        adminEnabled: supplier.adminEnabled,
        clientEnabled: supplier.clientEnabled,
      })

      return response
    },

    async updateSupplierVisibility(context, { supplierIds, admin, enable }) {
      const response = await http.put(
        `supplier/visibility` +
          `?supplierIds=${supplierIds}` +
          `&admin=${admin}` +
          `&enable=${enable}`
      )

      return response
    },
    async deleteSupplier(context, id) {
      const response = await http.delete(`supplier/${id}`)

      return response
    },
    async getSupplier(context, id) {
      const response = await http.get(`supplier/${id}`)

      return response
    },
    async searchSuppliers(context, params) {
      const response = await http.get(`supplier/search/${requestUrlFunction(params)}`)

      return response
    },
    async searchSupplierProducts(context, { supplierId, params, type }) {
      const response = await http.get(
        `/supplier/${supplierId}/product/search/${requestUrlFunction(params)}` +
          `&type=${type.toUpperCase()}`
      )

      return response
    },
    async createSupplierProduct(context, { supplierId, type, product }) {
      const response = await http.post(
        `supplier/${supplierId}/product` + `?type=${type.toUpperCase()}`,
        {
          name: product.name,
          adminEnabled: product.adminEnabled,
          clientEnabled: product.clientEnabled,
          fixed: product.fixed,
          type: isObject(product.type) ? product.type.name : product.type,
          status: isObject(product.status) ? product.status.name : product.status,
          contractType: isObject(product.contractType)
            ? product.contractType.name
            : product.contractType,
          contractPeriod: product.contractPeriod,
          contractPeriodUnit: isObject(product.contractPeriodUnit)
            ? product.contractPeriodUnit.name
            : product.contractPeriodUnit,
        }
      )

      return response
    },
    async updateSupplierProduct(context, { supplierId, productId, type, product }) {
      const response = await http.put(
        `supplier/${supplierId}/product/${productId}` + `?type=${type.toUpperCase()}`,
        {
          name: product.name,
          adminEnabled: product.adminEnabled,
          clientEnabled: product.clientEnabled,
          fixed: product.fixed,
          type: isObject(product.type) ? product.type.name : product.type,
          status: isObject(product.status) ? product.status.name : product.status,
          contractType: isObject(product.contractType)
            ? product.contractType.name
            : product.contractType,
          contractPeriod: product.contractPeriod,
          contractPeriodUnit: isObject(product.contractPeriodUnit)
            ? product.contractPeriodUnit.name
            : product.contractPeriodUnit,
        }
      )

      return response
    },
    async updateSupplierProductVisibility(
      context,
      { supplierId, productIds, type, admin, enable }
    ) {
      const response = await http.put(
        `supplier/${supplierId}/product/visibility` +
          `?type=${type.toUpperCase()}` +
          `&productIds=${productIds}` +
          `&admin=${admin}` +
          `&enable=${enable}`
      )

      return response
    },
    async deleteSupplierProduct(context, { supplierId, productId, type }) {
      const response = await http.delete(
        `supplier/${supplierId}/product/${productId}` + `?type=${type.toUpperCase()}`
      )

      return response
    },

    async getSupplierProduct(context, { supplierId, productId, type }) {
      const response = await http.get(
        `supplier/${supplierId}/product/${productId}` + `?type=${type.toUpperCase()}`
      )

      return response
    },
    async searchSupplierProductPrices(context, { supplierId, productId, type, params }) {
      const response = await http.get(
        `/supplier/${supplierId}/product/${productId}/price/${requestUrlFunction(params)}` +
          `&type=${type.toUpperCase()}`
      )
      return response
    },
    async createSupplierGift(context, { supplierId, giftId }) {
      const response = await http.post(`/supplier/${supplierId}/gift?giftId=${giftId}`)

      return response
    },
    async searchSupplierGifts(context, { supplierId, params }) {
      const response = await http.get(`/supplier/${supplierId}/gift/${requestUrlFunction(params)}`)

      return response
    },
    async deleteSupplierGift(context, { supplierId, giftId }) {
      const response = await http.delete(`/supplier/${supplierId}/gift/${giftId}`)

      return response
    },
    async createSupplierProductPrice(context, { supplierId, productId, type, prices }) {
      const response = await http.post(
        `/supplier/${supplierId}/product/${type.toLowerCase()}/${productId}/price`,
        prices
      )
      return response
    },
    async updateSupplierProductPrice(context, { supplierId, productId, type, priceId, prices }) {
      const response = await http.put(
        `/supplier/${supplierId}/product/${type.toLowerCase()}/${productId}/price/${priceId}`,
        prices
      )
      return response
    },
    async getSupplierProductPrice(context, { supplierId, productId, type, priceId }) {
      const response = await http.get(
        `/supplier/${supplierId}/product/${productId}/price/${priceId}` +
          `?type=${type.toUpperCase()}`
      )
      return response
    },
    async deleteSupplierProductPrice(context, { supplierId, productId, type, priceId }) {
      const response = await http.delete(
        `/supplier/${supplierId}/product/${productId}/price/${priceId}` +
          `?type=${type.toUpperCase()}`
      )
      return response
    },
    async createSupplierRating(context, { supplierId, values }) {
      const response = await http.post(`supplier/${supplierId}/rating`, {
        values: values,
      })
      return response
    },
    async updateSupplierRating(context, { supplierId, values }) {
      const response = await http.put(`supplier/${supplierId}/rating`, {
        values: values,
      })

      return response
    },
    async getSupplierRating(context, supplierId) {
      const response = await http.get(`supplier/${supplierId}/rating`)

      return response
    },
    async deleteSupplierRating(context, supplierId) {
      const response = await http.delete(`supplier/${supplierId}/rating`)

      return response
    },
  },
}
